<template>
  <el-dialog top="10vh" :visible="true" :close-on-click-modal="false" destroy-on-close append-to-body
    @close="$emit('close')" width="500px">
    <template #title>
      <span class="fw-bold font-size-24 ms-3">Lọc hội thoại</span>
    </template>
    <div>
      <el-checkbox v-model="configLocal.onlyPhone">Chỉ đồng bộ hội thoại có SĐT</el-checkbox>
    </div>
    <div class="divider-custom m-2" />
    <div>
      <div class="mb-2 fw-700">Lọc hội thoại theo tag</div>
      <div>
        <el-input v-model="searchTag" placeholder="Tìm tên thẻ" clearable class="mb-2" />
        <div class="d-flex flex-wrap text-center overflow-auto mt-2 px-1"
          style="max-width: 500px; max-height: 400px; min-width: 500px">
          <div v-for="(item, index) in filterTags" :key="index">
            <div class="d-flex pointer" @click="addOrRemoveTagAssign(item)">
              <TagV2 :data="item" :inactive="!isSelectedAssign(item)" :item="item" :selected="isSelectedAssign(item)"
                :is-button="true" />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <el-button type="primary" @click="saveFilter">
          Đồng ý
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import TagV2 from "../TagV2.vue";
export default {
  name: "DialogFilterSync",
  props: ["config", "accountId"],
  components: { TagV2 },
  data() {
    return {
      searchTag: "",
      selectedTagsAssign: [],
      onlyPhone: true,
      configLocal: {
        onlyPhone: true,
        tags: []
      }
    }
  },
  computed: {
    filterTags() {
      if (!this.searchTag) return this.app.tags;
      return this.app.tags.filter(tag =>
        tag.name.toLowerCase().includes(this.searchTag.toLowerCase())
      );
    },
  },
  methods: {
    addOrRemoveTagAssign(tag) {
      const index = this.configLocal.tags.indexOf(tag.id);
      if (index > -1) {
        this.configLocal.tags.splice(index, 1);
      } else {
        this.configLocal.tags.push(tag.id);
      }
    },
    isSelectedAssign(tag) {
      return this.configLocal.tags.includes(tag.id);
    },
    saveFilter() {
      this.$emit("saveFilter", this.configLocal);
    }
  },
  mounted() {
    if (!this.config) {
      this.configLocal = {
        onlyPhone: true,
        tags: []
      };
    } else if (typeof this.config === "string") {
      try {
        this.configLocal = JSON.parse(this.config);
      } catch (e) {
        console.error("Config parse error:", e);
        this.configLocal = {
          onlyPhone: true,
          tags: []
        };
      }
    } else {
      this.configLocal = { ...this.config };
    }
  }
}
</script>